import { useLocation } from 'react-router-dom'
import React, { useContext, useEffect, useState } from 'react'
import { sessionContext } from '@marketing-milk/frontend'
import posthog from 'posthog-js'
import { takeEntryRoute } from '../../../app/util/entry-route'
import { routerContext } from 'components/router/context/RouterContext'
import { RouterContextProps } from 'components/router/context/RouterContextTypes'

export function RouterContextProvider({ children }: RouterContextProps) {
  const location = useLocation()
  const { user } = useContext(sessionContext)
  const [routes, setRoutes] = useState<string[]>([])

  useEffect(() => {
    // A restored session can reach its destination without ever mounting Login.
    // Keep the destination during authentication, but retire it once signed in
    // on an application page (including an unavailable-page fallback).
    if (
      user &&
      !location.pathname.startsWith('/login') &&
      !location.pathname.startsWith('/invalid_user')
    ) {
      takeEntryRoute()
    }
  }, [user, location.pathname])

  useEffect(() => {
    setRoutes(_ => [..._, location.pathname + location.search])
    posthog.capture('$pageview')
  }, [location.pathname])

  return <routerContext.Provider value={routes}>{children}</routerContext.Provider>
}
